export enum TimeTrackingKind {
  OHNE_ANGABE = 'OHNE_ANGABE',
  VON_BIS = 'VON_BIS',
  ANZAHL = 'ANZAHL',
  STOPUHR = 'STOPUHR',
}
